import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSnippetsStore = defineStore('snippets', () => {
    const snippets = ref<Record<string, string>>({});
    const error = ref<Error | null>(null);
    const loading = ref(false);
    const initialized = ref(false);

    async function fetchSnippets() {
        if (initialized.value) return;

        loading.value = true;
        try {
            const response = await $fetch<Record<string, string>>('/api/getSnippets');
            snippets.value = response;
            initialized.value = true;
        } catch (err) {
            error.value = err as Error;
        } finally {
            loading.value = false;
        }
    }

    return {
        snippets,
        loading,
        initialized,
        fetchSnippets,
    };
});
